import { useEffect, useState } from 'react';

const useAnimatedNumber = ({ from, to, duration = 900, delay = 0 }) => {
  const [value, setValue] = useState(from);

  useEffect(() => {
    let rafId = null;
    let startTime = null;

    const tick = (now) => {
      if (startTime === null) startTime = now;
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(from + (to - from) * eased));
      if (progress < 1) rafId = requestAnimationFrame(tick);
    };

    const timerId = setTimeout(() => {
      rafId = requestAnimationFrame(tick);
    }, delay);

    return () => {
      clearTimeout(timerId);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [from, to, duration, delay]);

  return value;
};

export default useAnimatedNumber;
